import { render, staticRenderFns } from "./donut-chart.vue?vue&type=template&id=504e34ba&scoped=true&"
import script from "./donut-chart.vue?vue&type=script&lang=ts&"
export * from "./donut-chart.vue?vue&type=script&lang=ts&"
import style0 from "./donut-chart.vue?vue&type=style&index=0&id=504e34ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504e34ba",
  null
  
)

export default component.exports